import './CheckFrontendVersion.scss';

import { Button } from '@gravity-ui/uikit';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import i18n from 'src/libs/i18n';
import FrontendVersionStore from 'src/stores/FrontendVersion';

import locales from './CheckFrontendVersion.i18n';

const b = require('b_').with('check-frontend-version');

const __ = i18n(locales);

function CheckFrontendVersionComponent() {
	const [isHide, setIsHide] = useState(false);

	if (!FrontendVersionStore.isOutdated() || isHide) {
		return null;
	}

	return (
		<div className={b()}>
			<p>{__('updateAvailable')}</p>
			<div className={b('actions')}>
				<Button onClick={window.location.reload}>{__('update')}</Button>
				<Button onClick={() => setIsHide(true)}>{__('cancel')}</Button>
			</div>
		</div>
	);
}
const CheckFrontendVersion = observer(CheckFrontendVersionComponent);
export default CheckFrontendVersion;
